import { Button, Popover } from '@mui/material';
import * as React from 'react';
import Library from "@af-common/Resource/Library";
import LibraryBrowserContainer from '../../../LibraryBrowser/_containers/LibraryBrowserContainer';
import ModuleDimensionsContainer from '../../_containers/ModuleDimensionsContainer';
import ModuleDPIContainer from '../../_containers/ModuleDPIContainer';
import ModulePositionContainer from '../../_containers/ModulePositionContainer';
import ModuleRotationContainer from '../../_containers/ModuleRotationContainer';
import ModuleDuplicateContainer from '../../_containers/ModuleDuplicateContainer';
import { IImageStore } from '../../../ImageList/_stores/ImageStore';
import { UserImageStore } from '@af-common/UserData/_stores/UserImagesStore';
import { Trans } from "react-i18next";
import ModuleAttachToTileContainer from '../../_containers/ModuleAttachToTileContainer';
import ModuleFitToTileContainer from '../../_containers/ModuleFitToTileContainer';

export type Props = {
	moduleId: string
	moduleCount?: number,
	opened: boolean
	source?: string
	sourceRatio?: number,
	sourceWidth?: number,
	sourceHeight?: number,
	width?: number,
	height?: number,
	rotation?: number,
	documentWidth?: number,
	documentHeight?: number,
	onThumbnailChange?: Function
	onImageListAdd?: Function
	onImageListRemove?: Function
	removeModule?: Function,
	setDocumentWidth?: Function,
	setDocumentHeight?: Function,
	toggleLockRatio?: Function
	isAttached?: boolean
	updateModule: (moduleId:string, updates:{[key:string] : any}) => void
}

type State = {
	opened: boolean
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class ModuleImageSettings extends React.Component<Props, State> {
	private hasImage:boolean = false;

	state:State = { opened: false }

	componentDidMount() {
		if(!this.props.source) {
			this.setState({
				opened: true
			});
		}
	}

	private open = () => this.setState({opened: true})
	private close = () => {
		if(!this.hasImage) {
			this.props.removeModule();
		} else {
			this.setState({opened: false})
		}
	}

	private handleSourceChange = async (item:UserImageStore) => {
		this.hasImage = true;

		let image:IImageStore = {
			id: item.get('id'),
			name: item.get('name'),
			src: item.get('filename'),
			fileid: item.get('fileid'),
			width: item.get('width'),
			height: item.get('height'),
			chunked: item.get('chunked'),
		}

		this.setSource(image);
	}

	private setSource = async (image:IImageStore) => {
		let UserImages = Library.UserImageLibrary;

		await UserImages.retrieve(image);
		
		let source:any = UserImages.get(image.id);
		if(!source) return;

		let sourceValue = source.value;

		this.props.onImageListAdd(image);

		let width = source.extra.width
		let height = source.extra.height
		let r = width / height

		let updates: any = {
			source: image.id,
			sourceRatio: r,
			sourceWidth: width,
			sourceHeight: height,
			rotation: 0
		}

		if(this.props.moduleCount == 1){
			this.props.toggleLockRatio(false);
			this.props.setDocumentWidth(width);
			this.props.setDocumentHeight(height);
		} else {
			let bounded_width = width > this.props.documentWidth ? this.props.documentWidth : width
			let bounded_height = height > this.props.documentHeight ? this.props.documentHeight : height
			switch (Math.sign(r-1)) {
				case 1:
					width = bounded_width
					height = width / r
				case 0:
					if (bounded_width != width) {
						width = bounded_width
						height = width
					} else if (bounded_height != height) {
						height = bounded_height
						width = height
					}
				case -1:
					height = bounded_height
					width = height * r
			}
		}

		updates.x = width / 2
		updates.y = height / 2
		updates.width = width
		updates.height = height

		this.props.updateModule(this.props.moduleId, updates);
		this.props.onThumbnailChange(sourceValue.content.src);
	}

	render = () => {
		return <>
			{this.props.opened && !this.props.source && <LibraryBrowserContainer opened={this.state.opened} onOpen={this.open} onClose={this.close} onSelect={(item:UserImageStore) => this.handleSourceChange(item)}/>}
			
			{ this.props.sourceRatio ? 
				<ModuleDPIContainer moduleId={this.props.moduleId} sourceWidth={this.props.sourceWidth} sourceHeight={this.props.sourceHeight} sourceRatio={this.props.sourceRatio}/>
			: "" }

			<ModulePositionContainer moduleId={this.props.moduleId}/>
			<ModuleDimensionsContainer moduleId={this.props.moduleId} ratio={this.props.sourceRatio}/>
			<ModuleRotationContainer moduleId={this.props.moduleId}/>

			<div className="actions-wrapper">
				<ModuleAttachToTileContainer moduleId={this.props.moduleId} />
				<ModuleFitToTileContainer moduleId={this.props.moduleId} />
				<ModuleDuplicateContainer moduleId={this.props.moduleId}/>
			</div>

			{ /*<Button onClick={this.autoPattern.bind(this)}><T>Auto pattern</T></Button>*/ }
		</>
	}
}